var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mobile-nav-item",class:{ 'mobile-nav-item--active': _vm.isActiveItem },on:{"click":function($event){$event.stopPropagation();return _vm.handleMenuState()}}},[_c('span',[_vm._v(_vm._s(_vm.title))])])}
var staticRenderFns = []

export { render, staticRenderFns }